import React from 'react';
// SİHİRLİ KOD: Hem hydrate (canlandırma) hem de normal render motorunu içeri alıyoruz
import { hydrateRoot, createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
// CSS dosyanın adı App.css veya index.css ise aşağıyı ona göre bırak
import './index.css'; 

const container = document.getElementById('root');

// EĞER DÜKKANDA HAZIR FOTOĞRAF (HTML) VARSA ONU CANLANDIR (SEO İÇİN)
if (container.hasChildNodes()) {
  hydrateRoot(container, <App />);
} 
// YOKSA DÜKKANI SIFIRDAN İNŞA ET (NORMAL ÇALIŞMA)
else {
  const root = createRoot(container);
  root.render(<App />);
}
// Uygulamayı HelmetProvider zırhıyla sarıyoruz
const appArayuzu = (
  <HelmetProvider>
    <App />
  </HelmetProvider>
);

if (container.hasChildNodes()) {
  hydrateRoot(container, appArayuzu);
} else {
  const root = createRoot(container);
  root.render(appArayuzu);
}